export class RefereshModal {
    id:any;
    projectId: number;
    isReferesh?:boolean;
    status:any;
    isEdit?:boolean;
    isListView?:boolean;
    listType:string;
}
